import { Column } from "../entities/column";
import { RowNode } from "../entities/rowNode";
import { GridApi } from "../gridApi";
import { ColumnApi } from "../columnController/columnApi";
import { ColumnGroup } from "../entities/columnGroup";

export interface BaseExportParams {
    allColumns?: boolean;
    columnKeys?: (string | Column)[];
    fileName?: string;
    onlySelected?: boolean;
    onlySelectedAllPages?: boolean;

    skipColumnGroupHeaders?: boolean;
    skipColumnHeaders?:boolean;
    skipRowGroups?: boolean;
    skipPinnedTop?: boolean;
    skipPinnedBottom?: boolean;

    shouldRowBeSkipped?(params: ShouldRowBeSkippedParams): boolean;
    processCellCallback?(params: ProcessCellForExportParams): string;
    processHeaderCallback?(params: ProcessHeaderForExportParams): string;
    processGroupHeaderCallback?(params: ProcessGroupHeaderForExportParams): string;
    processRowGroupCallback?(params: ProcessRowGroupForExportParams): string;

    /** @deprecated */
    columnGroups?: boolean;
    /** @deprecated */
    skipGroups?: boolean;
    /** @deprecated */
    skipHeader?: boolean;
}

export interface ExportParams<T> extends BaseExportParams {
    prependContent?: T;
    appendContent?: T;
    /**
     * @deprecated Use prependContent
     */
    customHeader?: T;
    /**
     * @deprecated Use appendContent
     */
    customFooter?: T;
    getCustomContentBelowRow?: (params: ProcessRowGroupForExportParams) => T | undefined;
}

export type PackageFileParams<T> = T & {
    data: string[];
};

export interface CsvCell {
    data: CsvCellData;
    mergeAcross?: number;
}

export interface CsvCellData {
    value: string | null;
}

export type CsvCustomContent = CsvCell[][] | string;

export interface CsvExportParams extends ExportParams<CsvCustomContent> {
    columnSeparator?: string;
    suppressQuotes?: boolean;
}

export interface ShouldRowBeSkippedParams {
    node: RowNode;
    api: GridApi;
    context: any;
}

export interface ProcessCellForExportParams {
    value: any;
    accumulatedRowIndex?: number;
    node?: RowNode | null;
    column: Column;
    api: GridApi | null | undefined;
    columnApi: ColumnApi | null | undefined;
    context: any;
    type: string; // clipboard, dragCopy (ctrl+D), export
}

export interface ProcessHeaderForExportParams {
    column: Column;
    api: GridApi | null | undefined;
    columnApi: ColumnApi | null | undefined;
    context: any;
}

export interface ProcessGroupHeaderForExportParams {
    columnGroup: ColumnGroup;
    api: GridApi | null | undefined;
    columnApi: ColumnApi | null | undefined;
    context: any;
}

export interface ProcessRowGroupForExportParams {
    node: RowNode;
    api: GridApi | null | undefined;
    columnApi: ColumnApi | null | undefined;
    context: any;
}